import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsDate } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { CandidateType, InterviewType, SourceType, StEnum } from "@gtpl/shared-models/common-models";
import { GoneException } from "@nestjs/common";

export class interviewDTO{
    push(interview: interviewDTO) {
        throw new Error('Method not implemented.');
    }
   

    @ApiProperty()
    @IsNotEmpty({message: 'interview Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    interviewId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'interview Id should not be empty'})
    notificationId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'interviewDate Name should not be empty'})
    interviewDate: Date;

    @ApiProperty()
    interviewType: InterviewType;

    
    @ApiProperty()
    @IsNotEmpty({message: 'Mobile Number should not be empty'})
    interviewer: string;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 50 characters'})
    willing: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Qualification Name should not be empty'})
    interviewerMobileNo: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Technologies should not be empty'})
    plant: string;

    // @ApiProperty()
    // @IsNotEmpty({message: 'Stack should not be empty'})
    // stack: string;

    @ApiProperty()
    jobDescription: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Expected CTC should not be empty'})
    candidateName: string;

    @ApiProperty({
        enum: StEnum,
    })
    status: StEnum;
   

    @ApiProperty()
    @IsNotEmpty({message: 'Referred By should not be empty'})
    refereedBy: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 400 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 400 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
    
  
}